import { withDevtools, withGlitchTracking } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import { INITIAL_VESSEL_SPEC_STORE_STATE, VesselSpecStoreState } from '@navstation-portal/vessels/data-model/vessel';
import { signalStore, withComputed, withState } from '@ngrx/signals';
import { VESSEL_SPEC_STORE_ID } from './constants';
import { buildVesselSpecVm } from './vessel-spec-vm-builder';
import { withVesselSpecEffects } from './with-vessel-spec-effects';
import { withVesselSpecReducer } from './with-vessel-spec-reducer';

export const VesselSpecStore = signalStore(
  { providedIn: 'root' },
  withDevtools(VESSEL_SPEC_STORE_ID, withGlitchTracking()),
  withState<VesselSpecStoreState>(INITIAL_VESSEL_SPEC_STORE_STATE),
  withVesselSpecEffects(),
  withVesselSpecReducer(),
  withComputed((store) => {
    return {
      vm: computed(() => {
        const vesselSpec = store.vesselSpec();
        if (!vesselSpec) return;

        return buildVesselSpecVm(vesselSpec);
      }),
    };
  })
);
